import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from "rxjs/index";
import { ApiResponse } from "../models/api.response";
import { AppConfig } from '../constant';

@Injectable({
  providedIn: 'root'
})
export class ApiserviceService {

  constructor(private http: HttpClient) { }
  baseUrl: string = AppConfig.API_BASE_URL; //dev server [From 10.09.2025]
  // baseUrl: string = 'https://dev-dot-mtc-filetransfer.an.r.appspot.com/'; //dev server
  // baseUrl: string = 'https://live-dot-mtc-filetransfer.an.r.appspot.com/'; //Live Server
  //phpBaseUrl: string = 'https://app.transfercenter.jp/paypal/cancelSubscription.php'; //Live Server
  phpBaseUrl: string = AppConfig.PHP_BASE_URL+'/paypal/cancelSubscription.php'; //dev server
  localNode: string = ' http://localhost:3000/';


  compose(composeData:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'sendFileDatas', composeData);
  }

  createUser(userJson:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'signUpWithEmailAndPasswordUsingFirebase', userJson);
  }

  getAllOutboxMessages(uid:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'listSenderFileDatas', uid);
  }

  getDefaultSettings(uid:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'listDefaultSettingDatas', uid);
  }
  

  getplans(currency:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'fetchPlans',currency);
  }

  restoreDefaultSettings(uid:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'restoreDefaultSetting', uid);
  }

  saveDefaultSettings(settingJson:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateUserDefaultSetting', settingJson);
  }

  getTermsAndServices(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getTermsAndServices', '');
  }

  saveTermsAndServices(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'saveTermsAndServices', data);
  }

  updateTermServiceVerification(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateTermServiceVerification', data);
  }

  addNotification(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'addNotification', data);
  }

  getNotificationList(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getNotificationList', '');
  }

  getNotificationDetails(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getNotificationDetails', data);
  }

  updateNotification(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateNotification', data);
  }

  deleteNotification(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteNotification', data);
  }

  toggleNotificationStatus(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'toggleNotificationStatus', data);
  }

  userIDcheck(uid:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'ifUidExist', uid);
  }

  brandCheck(brandurl:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'ifBrandExist', brandurl);
  }

  emailCheck(email:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'ifEmailExist', email);
  }

  choosePlan(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'fetchPlansWrtId', id);
  }

  getAllSmsPlans(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getAllSmsPlans', '');
  }

  updateUserSMSCount(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateUserSMSCount', body);
  }

  // SUBHENDU ADDED HERE
  updateUserSignup(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateUserSignup', id);
  }
  checkPaymentStatusWrtEmail(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'checkPaymentStatusWrtEmail', id);
  }



  // SAMRAT ADDED HERE 
  getTransferDetails(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getFileDataWrtKey', id);
  }
  
  deleteMessage(keyVal:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteTransfer', keyVal);
    // return this.http.post<ApiResponse>(this.baseUrl+'/sendFileDatas', composeData);
  }

  deleteMultipleTransfers(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'multipleDeleteTransfer', body);
  }

  changeTransferStatus(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'changeTransferStatus', body);
  }

  getUserDetails(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getUserDetails', id);
  }

  updateUserAccountGeneral(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateGeneralAccount', body);
  }

  getPaymentBills(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getPaymentDataWrtUid', id);
  }

  getInvoiceDetails(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getInvoiceDetailWrtPlanUniqueId', id);
  }

  updateUserLogoCustomBranding(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateUserCustomBranding', body);
  }

  getFreelancerDetails(brandUrl:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getFreelancerBrandDetails', brandUrl);
  }

  onClickSignUpButton(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'onClickSignUpButton',data);
  }

  onClickTryOutButtonWhileSignUp(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'onClickTryOutButtonWhileSignUp', data);
  }

  updateTransfer(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateFileDatas', data);
  }

  getSmsPurchaseHistory(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getSmsPurchaseHistory', id);
  }

  getSmsInvoice(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getSmsInvoice', id);
  }

  getSmsConsumptionHistory(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getSmsConsumptionHistory', id);
  }

  downloadTracking(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getDownloadTrackingDetails', data);
  }

  membersRegistration(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'membersRegistration', data);
  }

  getMemberList(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'listMembers', data);
  }

  getAllCollection(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'listCollectionWrtParentUid', data);
  }

  deleteCollection(keyVal:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteCollection', keyVal);
  }

  deleteMember(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteMember', body);
  }

  getCollectionDetails(keycode:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getCollectionDataWrtKey', keycode);
  }

  saveOperationLog(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'saveOperationLog', data);
  }

  saveOperationLogArray(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'saveOperationLogS', data);
  }

  getOperationLog(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getOperationLogWrtUid', data);
  }


  onClickTransferButtonFreeVersion(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'onClickTransferButtonFreeVersion',data);
  }

  onClickSignUpFreeVersion(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'onClickSignUpFreeVersion',data);
  }

  addCustomTemplate(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'addCustomTemplate', body);
  }

  updateTemplate(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateTemplate', body);
  }

  listTemplates(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'listTemplates', data);
  }

  deleteTemplates(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteTemplate', data);
  }

  importAddressbookCSV(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'importAdressBook', data);
  }

  getAddressBook(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getAddressBook', data);
  }
  
  deleteContact(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteContact', data);
  }

  addBusinessMember(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'addBusinessMember', data);
  }

  importBusinessMembers(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'importBusinessMembers', data);
  }

  getBusinessMember(data:any, context?: HttpContext): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getBusinessMember', data, context ? { context } : {});
  }

  takeMemberAction(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'takeMemberAction', data);
  }

  getMemberInfo(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getMemberInfo', data);
  }

  completeMemberRegistration(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'completeMemberRegistration', data);
  }

  updateContact(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateContact', body);
  }

  resendInvitation(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'resendInvitation', body);
  }

  updateDefaultDownloadDomain(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateDefaultDownloadDomain', body);
  }

  reportIssue(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'reportIssue', body);
  }

  getBusinessVersionWithOutFreeTrialPlans(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getBusinessVersionWithOutFreeTrialPlans', body);
  }

  checkUserType(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'checkUserType', body);
  }

  getChildUsers(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getChildUsers', body);
  }

  getMemberTransferList(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getMemberTransferList', body);
  }

  getOperationLogCSV(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getOperationLogCSV', data);
  }

  lockMemberAccount(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'lockMemberAccount', data);
  }

  getMemberAccess(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getMemberAccess', data);
  }

  updateMemberAccess(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateMemberAccess', data);
  }

  updateMemberUserDefaultSetting(settingJson:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateMemberUserDefaultSetting', settingJson);
  }

  listMemberDefaultSettingDatas(uid:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'listMemberDefaultSettingDatas', uid);
  }

  enroll_mfa(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'enroll_mfa', id);
  }
  
  verify_totp(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'verify_totp', id);
  }

  memberCurrentStateManage(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'memberCurrentStateManage', body);
  }

  makeAdminUser(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'makeAdminUser', body);
  }
  
  getContactGroup(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getContactGroup', data);
  }
  addContactGroup(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'addContactGroup', data);
  }
  
  deleteGroup(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteGroup', data);
  }

  updateGroupName(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateGroupName', data);
  }
  enable_mfa(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'enable_mfa', id);
  }

  requestSSLCertificate(domain:any): Observable<ApiResponse>{
    return this.http.post<ApiResponse>(this.baseUrl+'request-ssl', domain);
  }
  checkCertificateStatus(certificateArn:any): Observable<any>{
    const encodedArn = encodeURIComponent(certificateArn);
    return this.http.get<ApiResponse>(this.baseUrl+'certificate-status/'+encodedArn);
  }
  validateAndAttachCertificate(domain:any): Observable<ApiResponse>{
    return this.http.post<ApiResponse>(this.baseUrl+'validate-and-attach', domain);
  }  
  
  listDomain(id:any): Observable<ApiResponse>{
    return this.http.post<ApiResponse>(this.baseUrl+'listDomain', id);
  }
  allDomain(id:any): Observable<ApiResponse>{
    return this.http.post<ApiResponse>(this.baseUrl+'allDomain', id);
  }
  addDomain(domain:any): Observable<ApiResponse>{
    return this.http.post<ApiResponse>(this.baseUrl+'addDomain', domain);
  }
  updateDomain(domain:any): Observable<ApiResponse>{
    return this.http.post<ApiResponse>(this.baseUrl+'updateDomain', domain);
  }
  deleteDomain(domain:any): Observable<ApiResponse>{
    return this.http.post<ApiResponse>(this.baseUrl+'deleteDomain', domain);
  }
  deleteAwsCert(domain:any): Observable<ApiResponse>{
    return this.http.post<ApiResponse>(this.baseUrl+'smart-delete', domain);
  }
  checkDuplicateDomain(domain:any): Observable<ApiResponse>{
    return this.http.post<ApiResponse>(this.baseUrl+'checkDuplicateDomain', domain);
  }

  getGeoLocation(certificateArn:any): Observable<any>{
    return this.http.get<ApiResponse>(this.baseUrl+'geoip/location');
  }
  
  changeNoticeStatus(body:any): Observable<any>{
    return this.http.post<ApiResponse>(this.baseUrl+'changeNoticeStatus',body);
  }

  sendMessage(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('https://chatbot.appeaseonlinestore.com/chatbot/query/chat', body);
  }

  purchaseMember(data: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl + 'purchaseMember', data);
  }

  




  //Subhendu API Start
  changePlanSendOtp(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'changePlanSendOtp', id);
  }
  changePlanCheckOtp(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'changePlanCheckOtp', id);
  }
  planCancel(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'planCancel', id);
  }
  updateSubscription(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateSubscription', id);
  }
  cancelSubscription(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.phpBaseUrl, id);
  }
  undoCancelledSubscription(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'undoCancelledSubscription', id);
  }
  deleteAccount(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteAccount', id);
  }
  applyCoupon(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'applyCoupon', data);
  }
  verifyEmailSendOtp(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'verifyEmailSendOtp', data);
  }
  verifyEmailCheckOtp(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'verifyEmailCheckOtp', data);
  }
  getUserAllPlanDetails(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getUserAllPlanDetails', id);
  }
  onClickPaypalButtonWhileSignUp(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'onClickPaypalButtonWhileSignUp', id);
  }
  onClickNextButtonWhileSignUp(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'onClickNextButtonWhileSignUp', id);
  }
  insertPlanCancelServay(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'insertPlanCancelServay', id);
  }
  updatePlanCancelSurvey(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updatePlanCancelSurvey', id);
  }
  deleteLastTransfer(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteLastTransfer', body);
  }
  //Subhendu API End






  // SUPERADMIN API
  dashboard(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'dashboard', '');
  }
  getUserCountBasedOnSubscription(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getUserCountBasedOnSubscription', '');
  }

  usersList(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getDataForActiveSuspendedFreelanceUsers', '');
  }

  cancelUsersList(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getDataForPlanCancelledUsers', '');
  }

  getDataForSuspendedUsers(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getDataForSuspendedUsers', '');
  }

  getDataForBusinessUsers(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getDataForBusinessUsers', '');
  }

  addAffiliate(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'addAffiliate', data);
  }

  affiliateList(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'affiliateList', '');
  }

  affiliateDelete(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteAffiliate', id);
  }

  affiliateSelect(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'affiliateDetails', id);
  }

  affiliateEdit(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'editAffiliate', data);
  }

  affiliateStatusChange(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'changeAffiliateStatus', data);
  }
  
  affiliateFilter(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'monthlyReport', data);
  }

  getStorages(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getTotalStorage', '');
  }

  getPOusersList(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getPOusersList', '');
  }

  updatePOuser(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updatePOuser', data);
  }
  
  getDataForChildBusinessUsers(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getDataForChildBusinessUsers', data);
  }

  getAllReportIssues(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getAllReportIssues', '');
  }

  getReportIssueDetails(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getReportIssueDetails', data);
  }

  reportIssueStatusUpdate(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'reportIssueStatusUpdate', data);
  }

  readIssue(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'readIssue', data);
  }
  changeBusinessUserStatus(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'changeBusinessUserStatus', data);
  }
  updatePoSubscription(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updatePoSubscription', id);
  }

  updateBusinessUserSubscriptionDuration(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateBusinessUserSubscriptionDuration', data);
  }

  addCompanyCode(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'addCompanyCode', data);
  }

  listCompanyCodes(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'listCompanyCodes', '');
  }

  getCompanyCode(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getCompanyCode', id);
  }

  deleteCompanyCode(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteCompanyCode', body);
  }

  getUserPlanDetailsWithUID(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getUserPlanDetailsWithUID', body);
  }

  deleteInvoice(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteInvoice', id);
  }

  saveInvoice(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'saveInvoice', id);
  }

  fetchInvoiceDetails(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'fetchInvoiceDetails', id);
  }

  editInvoice(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'editInvoice', id);
  }

  getDataForBusinessUsersNew(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getDataForBusinessUsersNew', '');
  }

  deleteScheduledPlan(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteScheduledPlan', id);
  }

  getAddressBookGroupDetails(id:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getAddressBookGroupDetails', id);
  }

  getUserHistory(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getUserHistory', '');
  }

  getSuspendedAndCanceledUsersList(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getSuspendedAndCanceledUsersList', '');
  }

  updateTestAccount(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'updateTestAccount', data);
  }

  changeInvoiceView(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'changeInvoiceView', data);
  }

  searchUser(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'getUserDetailsByEmailOrUid', data);
  }

  //MARK: Domain Check
  isDomainExist(domain:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'isDomainExist', domain);
  }

  deleteMemberInvoice(data:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'deleteMemberInvoice', data);
  }
  
  fetchPurchasePlanDetails(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'fetchPurchasePlanDetails', body);
  }
  childToMasterAssign(body:any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl+'childToMasterAssign', body);
  }

}
